/**
 * Pixi {@link Assets.loadBundle} names and lobby-thumb aliases from asset-dataset-manifest.
 * Not MatchType wire values — naming follows product modes only.
 */
export const assetBundleOutpostRuns = 'outpostRuns';
export const assetBundleZoneRush = 'zoneRush';
export const assetLobbyThumbOutpostRun = 'outpostRunLobby';
export const assetLobbyThumbZoneRush = 'zoneRushLobby';
export const assetLobbyThumbTerraforming = 'terraformingLobby';
